"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgVirtualVisitSecondary = function SvgVirtualVisitSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M20.49 7.6H2.81A2.09 2.09 0 00.72 9.69V23a2.09 2.09 0 002.09 2.09h17.68A2.09 2.09 0 0022.58 23V9.69a2.09 2.09 0 00-2.09-2.09zm-.31 15.13H3.12V10h17.06v12.73zM24.81 13.18v6.37L31.28 23V9.74l-6.47 3.44zM28.88 19l-1.66-.89v-3.49l1.66-.89V19z" })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgVirtualVisitSecondary);